var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavicon19(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4042 4.09326C13.2514 4.09326 13.0986 4.09326 12.9501 4.11024C13.2676 4.92822 13.4219 5.80048 13.4042 6.67775C13.4042 9.49565 11.8827 12.0292 10.1852 13.0202C11.051 14.4015 12.2753 15.3076 13.402 15.3076C15.4476 15.3076 17.7859 12.3581 17.7859 8.97791C17.7859 5.5977 15.8253 4.09326 13.4042 4.09326Z",
    fill: "#7A67FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.6,
    d: "M12.9437 4.11029C12.1946 2.2812 10.5777 1.44092 8.69985 1.44092C6.10475 1.44092 4.00194 3.05357 4.00194 6.6778C4.00194 10.302 6.51853 13.4679 8.69985 13.4679C9.22515 13.4539 9.73747 13.3017 10.1852 13.0266C9.43037 11.8167 9.02635 10.4209 9.01814 8.99493C9.02026 5.81206 10.7433 4.29065 12.9437 4.11029Z",
    fill: "url(#paint0_linear_19474_2464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.4041 6.67787C13.4198 5.80017 13.2634 4.9279 12.9437 4.11035C10.7369 4.29071 9.01389 5.80788 9.01389 8.97802C9.02209 10.404 9.42612 11.7998 10.1809 13.0097C11.8827 12.0293 13.4041 9.49577 13.4041 6.67787Z",
    fill: "#7A67FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    filter: "url(#filter0_f_19474_2464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4041 6.67787C13.4198 5.80017 13.2634 4.9279 12.9437 4.11035C10.7369 4.29071 9.01389 5.80788 9.01389 8.97802C9.02209 10.404 9.42612 11.7998 10.1809 13.0097C11.8827 12.0293 13.4041 9.49577 13.4041 6.67787Z",
    fill: "#7B55DF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.635 11.0914C10.5848 11.0914 10.5358 11.0754 10.4954 11.0456C10.4549 11.0158 10.425 10.9739 10.4101 10.9259C10.2079 10.2963 10.1042 9.63925 10.1024 8.97799C10.1024 7.56691 10.478 6.52718 11.2164 5.88848C11.2401 5.86813 11.2676 5.85264 11.2972 5.8429C11.3269 5.83317 11.3582 5.82937 11.3893 5.83174C11.4205 5.8341 11.4508 5.84258 11.4787 5.85668C11.5065 5.87079 11.5313 5.89025 11.5517 5.91394C11.572 5.93745 11.5874 5.96473 11.5971 5.99423C11.6068 6.02372 11.6106 6.05485 11.6082 6.08581C11.6059 6.11677 11.5974 6.14696 11.5833 6.17464C11.5693 6.20232 11.5498 6.22694 11.5262 6.24708C10.8896 6.79242 10.5777 7.7112 10.5777 8.97799C10.5793 9.59093 10.6752 10.2 10.8621 10.7837C10.8807 10.8437 10.8749 10.9085 10.8459 10.9642C10.8168 11.0199 10.767 11.0618 10.7072 11.0808C10.6837 11.0876 10.6594 11.0912 10.635 11.0914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.8433 15.2607C13.5538 15.323 13.2544 15.323 12.9649 15.2607L12.3071 16.4193H14.5118L13.8433 15.2607Z",
    fill: "#7A67FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.2471 16.4194H13.5633V19.8675H13.2471V16.4194Z",
    fill: "#7A67FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M5.72915 8.92473C5.68111 8.92211 5.63503 8.90485 5.59709 8.87526C5.55916 8.84567 5.53119 8.80518 5.51696 8.75922C5.30225 8.08614 5.19204 7.38411 5.19019 6.67762C5.19019 5.17106 5.58911 4.0613 6.37634 3.38017C6.39974 3.35983 6.42693 3.34429 6.45634 3.33446C6.48575 3.32462 6.5168 3.32068 6.54774 3.32284C6.57867 3.32501 6.60888 3.33325 6.63663 3.34709C6.66438 3.36093 6.68913 3.3801 6.70948 3.40351C6.72982 3.42692 6.74535 3.4541 6.75519 3.48351C6.76502 3.51292 6.76897 3.54398 6.7668 3.57491C6.76463 3.60585 6.75639 3.63605 6.74255 3.6638C6.72871 3.69155 6.70954 3.71631 6.68613 3.73665C6.00712 4.32442 5.66337 5.31323 5.66337 6.67762C5.66456 7.33599 5.76763 7.99021 5.96893 8.61705C5.98757 8.67699 5.98175 8.74187 5.95273 8.79752C5.92371 8.85318 5.87384 8.89509 5.81403 8.91412C5.78675 8.92338 5.75787 8.92699 5.72915 8.92473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.6,
    d: "M9.17725 13.4126C8.86658 13.4777 8.54579 13.4777 8.23512 13.4126L7.51791 14.6539H9.89234L9.17725 13.4126Z",
    fill: "url(#paint1_linear_19474_2464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.6,
    d: "M8.54707 14.6538H8.86324V19.8695H8.54707V14.6538Z",
    fill: "url(#paint2_linear_19474_2464)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_19474_2464",
    x: 7.36389,
    y: 2.46035,
    width: 7.69131,
    height: 12.1994,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.825,
    result: "effect1_foregroundBlur_19474_2464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19474_2464",
    x1: 4.00194,
    y1: 7.45442,
    x2: 12.9437,
    y2: 7.45442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7967FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19474_2464",
    x1: 7.51791,
    y1: 14.0333,
    x2: 9.89234,
    y2: 14.0333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7967FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19474_2464",
    x1: 8.54707,
    y1: 17.2616,
    x2: 8.86324,
    y2: 17.2616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7967FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon19);
export default __webpack_public_path__ + "static/media/navicon19.79ec1e3549cd5d51f2d4a8de029c0f1f.svg";
export { ForwardRef as ReactComponent };